import { CommApiInstance } from "Utils/CommApiInstance";

const GameSvcMnyDpstPrdtAllLstApi = async (
    gameSvcCd: string | null,
    prdtKindCd: string,
) => {
    return await CommApiInstance.post(`pymt/${gameSvcCd}/${prdtKindCd}/prdt_all_lst`, {
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default GameSvcMnyDpstPrdtAllLstApi;
